<template>
    <v-container grid-list-sm text-xs-left>
        <v-form ref="form">
            <v-text-field
                    v-model="user.username"
                    label="Username"
                    :rules="[rules.required, rules.max, rules.min3]"
                    :counter="32"
                    required
                    @input="$v.username.$touch()"
                    @blur="$v.username.$touch()"
            />
            <v-text-field
                    v-if="!disablePassword"
                    v-model="user.password"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :type="showPassword ? 'text' : 'password'"
                    :rules="[rules.required, rules.min8]"
                    label="Password"
                    required
                    @click:append="showPassword = !showPassword"
                    @input="$v.password.$touch()"
                    @blur="$v.password.$touch()"
            />
            <v-text-field
                    v-if="!disablePassword"
                    v-model="user.confirmPassword"
                    :append-icon="showPasswordConfirmed ? 'visibility_off' : 'visibility'"
                    :type="showPasswordConfirmed ? 'text' : 'password'"
                    :rules="[rules.required, rules.min8, passwordConfirmationRule]"
                    label="Confirm Password"
                    required
                    @click:append="showPasswordConfirmed = !showPasswordConfirmed"
                    @input="$v.confirmPassword.$touch()"
                    @blur="$v.confirmPassword.$touch()"
            />
            <v-text-field
                    v-model="user.firstName"
                    label="First Name"
                    required
                    @input="$v.firstName.$touch()"
                    @blur="$v.firstName.$touch()"
            />
            <v-text-field
                    v-model="user.lastName"
                    label="Last Name"
                    required
                    @input="$v.lastName.$touch()"
                    @blur="$v.lastName.$touch()"
            />
            <v-text-field
                    v-model="user.email"
                    :rules="[rules.email,rules.required]"
                    label="E-mail"
                    required
                    @input="$v.email.$touch()"
                    @blur="$v.email.$touch()"
            />
            <v-select
                    v-model="user.role"
                    :items="roles"
                    :rules="[rules.required]"
                    label="Role"
                    required
                    @change="$v.role.$touch()"
                    @blur="$v.role.$touch()"
            />
            <v-select
                    v-model="user.group"
                    :items="groups"
                    label="Group"
                    item-text="name"
                    required
                    return-object
                    :rules="[rules.required]"
                    @change="$v.group.$touch()"
                    @blur="$v.group.$touch()"
            />

            <v-flex class="mt-3">
                <v-btn round dark color="green" @click="submit">
                    Submit
                </v-btn>
                <v-btn round dark color="red" @click="clear">
                    Clear
                </v-btn>
            </v-flex>
        </v-form>

        <v-dialog v-model="registrationStatus" max-width="450">
            <v-card v-if="registrationError===409">
                <v-card-title class="headline error white--text">Creation failed</v-card-title>
                <v-card-text>User with this username already exists!</v-card-text>
            </v-card>
            <v-card v-else-if="registrationError===200">
                <v-card-title class="headline success white--text">New user successfully created</v-card-title>
                <v-card-text>The new user will receive an email with the credentials.</v-card-text>
            </v-card>
            <v-card v-else>
                <v-card-title class="headline error white--text">Creation failed</v-card-title>
                <v-card-text>Something went wrong... Retry!</v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import {validationMixin,} from "vuelidate";
    import {email, maxLength, minLength, required,sameAs} from "vuelidate/lib/validators";
    import UrlsService from "@/helpers/UrlsService";
    import TimeService from "@/helpers/TimeService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import {mapGetters,mapState} from "vuex";


    export default {
        name: "NewUser",
        components: {},
        mixins: [validationMixin,],
        validations: {
            username: {required, minLength: minLength(3), maxLength: maxLength(32)},
            password: {required, minLength: minLength(8)},
            confirmPassword: {required, minLength: minLength(8),sameAsPassword: sameAs('password')},
            email: {email,required},
            role: {required},
            group: {required},
            firstName: {},
            lastName: {},
        },

        data: () => ({
            rules: {
                required: value => !!value || 'Required',
                min8: v => v.length >= 8 || 'Password must be at least 8 characters long',
                min3: v => v.length >= 3 || 'Username must be at least 3 characters long',
                max: v => v.length <= 32 || 'Username must be at most 32 characters long',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return value === '' || pattern.test(value) || 'Invalid e-mail'
                }
            },
            user: {
                username: "",
                password: "",
                confirmPassword: "",
                firstName: "",
                lastName: "",
                email: "",
                role: null,
                group: null
            },
            newUser: false,
            registrationStatus: false,
            registrationError: 200,
            showPassword: false,
            showPasswordConfirmed: false,
            roles: [
                "Admin", "User", "Customer","Customer + chat","Radar"
            ],
            disablePassword: false
        }),

        computed: {
            ...mapState({}),
            ...mapGetters('UserState', {
                    userInfo: 'getUserInfo',
                }
            ),
            passwordConfirmationRule() {
                return () => (this.password === this.confirmPassword) || 'Password must match'
            },
        },
        props:["groups"],
        created(){
            if(this.userInfo.role === "APPROVER_INNOVATION"){
                this.roles.push("Approver")
            }
        },
        methods: {
            disablePasswordFunction(disable){
                this.disablePassword = disable;
            },
            fillFields(item){
                this.user = item;
                if(item.roleId === 6) this.user.role = "Admin";
                else if(item.roleId === 9) this.user.role = "Customer";
                else if(item.roleId === 10) this.user.role = "Customer + chat";
                else if(item.roleId === 11) this.user.role = "Approver";
                else if(item.roleId === 13) this.user.role = "Radar";

                else this.user.role = "User";
                for (let i=0; i<this.groups.length; i++){
                    if(this.groups[i].id === item.groupId){
                        this.user.group = this.groups[i];
                        break;
                    }
                }
            },
            setNewUser(value){
                this.newUser = value;
            },
            submit() {
                this.$v.$touch();
                if(this.$refs.form.validate()) {
                    if(this.newUser){
                        this.createNewUser();
                    }
                    else {
                        this.updateUser();
                    }
                }
            },
            updateUser(){
                let roleId = 0;
                if(this.user.role === "Admin") roleId = 6;
                else if (this.user.role === "Customer") roleId = 9;
                else if (this.user.role === "Customer + chat") roleId = 10;
                else if (this.user.role === "Approver") roleId = 11;
                else if (this.user.role === "Radar") roleId = 13;
                else roleId = 7;

                let requestUrl = {
                    url: UrlsService.user + "/" + this.user.id,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    confirmPassword: this.user.confirmPassword,
                    email: this.user.email,
                    firstName: this.user.firstName,
                    lastName: this.user.lastName,
                    organizationId: 1,
                    password: this.user.password,
                    roleId: roleId,
                    username: this.user.username,
                    groupId: this.user.group.id

                };
                let requestObject = {
                    type: "superAdmin",
                    urlsInfo: requestUrl,
                    data: {
                        method: "patch",
                        data: requestData
                    },
                };
                let messages = {
                    title: "Update user",
                    loading: "Updating",
                    error: "Server Error",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };

                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let response = responseSuccess;
                        this.$emit("submit")
                        if(response.email !== ""){
                            response.password = this.user.password;
                        }
                        this.clear();
                    });

            },
            createNewUser(){
                let roleId = 0;
                if(this.user.role === "Admin") roleId = 6;
                else if(this.user.role === "Customer") roleId = 9;
                else if(this.user.role === "Customer + chat") roleId = 10;
                else if(this.user.role === "Approver") roleId = 11;
                else if(this.user.role === "Radar") roleId = 13;
                else roleId = 7;

                let requestUrl = {
                    url: UrlsService.user,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    email: this.user.email,
                    firstName: this.user.firstName,
                    lastName: this.user.lastName,
                    organizationId: 1,
                    password: this.user.password,
                    confirmPassword: this.user.confirmPassword,
                    roleId: roleId,
                    username: this.user.username,
                    groupId: this.user.group.id
                };
                let requestObject = {
                    type: "superAdmin",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData
                    },
                };
                let messages = {
                    title: "Create new user",
                    loading: "Creating",
                    error: "Server Error",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };

                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let response = responseSuccess;
                        this.registrationStatus = true;
                        if(response.response !== undefined) {
                            this.registrationError = response.response.status;
                        } else{
                            this.registrationError = 200;
                            this.$emit("submit")
                            this.clear();
                        }

                    });

            },
            clear() {
                this.showPassword= false;
                this.showPasswordConfirmed = false;
                this.user.username = "";
                this.user.password = "";
                this.user.confirmPassword = "";
                this.user.firstName = "";
                this.user.lastName = "";
                this.user.email = "";
                this.user.role = null;
                this.user.group = null;
            },
        },
    };
</script>

<style lang="scss">
</style>

